enum CompanySize {
  SME = "SME",
  MID_MARKET = "Mid Market",
  CORPORATE = "Corporate"
}

export default CompanySize
